// extracted by mini-css-extract-plugin
module.exports = {"PaymentWrapper":"Payment_PaymentWrapper__sQmmB"};